import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyInn as SchemaCompanyInn } from '../schemas/CompanyInn';
import { type SetCompanyInnRequest as SchemaSetCompanyInnRequest } from '../schemas/SetCompanyInnRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyInnContentType = 'application/json' as const;
export type SetCompanyInnRequest = SchemaSetCompanyInnRequest;
export type SetCompanyInnResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful update company INN
     */
    '200': {
        'application/json': SchemaCompanyInn;
    };
};
export type SetCompanyInnResponseSuccess = SetCompanyInnResponses['200']['application/json'];
export type SetCompanyInnSearchParams = undefined;
export type SetCompanyInnPathParameters = undefined;
export const SetCompanyInnUrl = '/company/inn' as const;
export const SetCompanyInnMethod = 'POST' as const;
export const getSetCompanyInnUrl = (_params?: SetCompanyInnPathParameters) => SetCompanyInnUrl;
